import { render } from "./TasksList.vue?vue&type=template&id=7c1b508a&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=7c1b508a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c1b508a"

export default script